var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 126,
    viewBox: "0 0 80 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59717 4.74512L76.2412 66.2061",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44318 121.254L72.3942 66.2061",
    stroke: "white",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.69b870a65c13e936a9730e81a7f4a5a7.svg";
export { ForwardRef as ReactComponent };